import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import { setStorage} from "@/utils";
import { tableData,tableData1} from './data'
import './index.scss'
import {expertmuseumscoredetail} from "@/servers/goodsManageApi";


import { newmuseumqueryHanndler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {message, Modal} from 'antd'
import {getALLMenu} from "../../../../servers/menuAPI";
import {setLbname, setLibrary, setMenu, setYear} from "../../../../redux/common/action";
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.deleteHandler = this.deleteHandler.bind(this);
        this.modalOk = this.modalOk.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.searchHandler = this.searchHandler.bind(this)
        this.resetHandler = this.resetHandler.bind(this)
        this.onChange = this.onChange.bind(this)
        this.changeitem = this.changeitem.bind(this)
        this.gotoindex =  this.gotoindex.bind(this)
        this.onTableChange = this.onTableChange.bind(this)
        this.gotoDetail = this.gotoDetail.bind(this)
        this.download = this.download.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getListData();
    }


    state = {
        columns: tableData.tHead,
        dataSource: tableData.tBody,
        dataSourceAll:[],
        page: tableData.tPage,
        columns1: tableData1.tHead,
        dataSource1: tableData1.tBody,
        dataSource1all: tableData1.tBody,
        loading: true,
        level:0,
        modal: {
            title: '',
            visible: false,
        },
        deleteid:'',
        annual: '',
        levelid: '',
        ownerlist:[],
        options:[],
        citylist:[],
        detaildata:[],
        museumname:'',
        provinceid:'',
        special:'',
        resultlist:[],
        speciallist:[],
        yearrange1:[],
    };


    searchHandler(){
        this.getListData()
    }
    download(){
        const params = {
            annual:this.state.annual,
            result:this.state.result,
            minscore:this.state.minscore,
            maxscore:this.state.maxscore,
            special:this.state.special,
            levelid:this.state.levelid,
            provinceid:this.state.provinceid === -1 ? '' : this.state.provinceid,
            museumname:this.state.museumname,
            export:1
        }
        newmuseumqueryHanndler(params).then(res=>{
            console.log(res);
            if (res.statecode === 0) {
                window.location.href = res.records[0].download
            } else {
                message.error(res.statemessage)
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }

    onChange(name,data){
        this.setState({
            [name]:data
        })
    }

    resetHandler(){
        this.setState({
            annual:'',
            result:'',
            minscore:'',
            maxscore:'',
            special:'',
            provinceid:'',
            levelid: '',
            museumname:''
        },()=>{
            this.getListData()
        })
    }

    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false},
            dataSource1:[],
            dataSource1All:[]
        })
    }

    modalOk(){
        // const params = {
        //   id: this.state.deleteid
        // }
        // expertdelete(params).then(res=>{
        //   if (res.statecode === 0) {
        //     message.success('删除成功');
        //     this.modalCancel()
        //     this.getListData()
        //   } else {
        //     message.error('删除失败');
        //   }
        // })
    }

    onTableChange(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

    gotoindex(data,year){
        console.log(year);
        const params = {
            annual:year,
            museumid:data.id
        }
        getALLMenu(params).then(res=>{
            const result =  this.changeitem(res.records)
            setStorage('menu', result);
            this.props.setMenu(result);
            setStorage('year', year);
            this.props.setYear(year);
            setStorage('lbname', data.name);
            this.props.setLbname(data.name);
            setStorage('showids','1.1.1')
            this.props.setLibrary(data.id);
            setStorage('library',data.id)
            localStorage.setItem('chooseid','101110')
            this.props.history.push({
                pathname: '/informationDeclaration/museumbaseinfoCentral',
            });
        })
    }

    gotoDetail(data){
        console.log(data);
        const params = {
            museumid:data.id,
            annual:this.state.annual
        }
        expertmuseumscoredetail(params).then(res=>{
            if (res.statecode === 0) {
                this.setState({
                    modal: {...this.state.modal, visible: true,title:'评分详情:'+data.name}
                });
                setTimeout(()=>{
                    this.setState({
                        dataSource1:res.records,
                        dataSource1all:res.records,
                    })
                })
            }
        })
    }
    getAlertSelect(data){
        const params = []
        this.state.dataSource1all.forEach(item=>{
            if(Number(data) === 4) {
                params.push(item)
            } else {
                if (Number(item.rank) <= Number(data)) {
                    params.push(item)
                }
            }
        })
        this.setState({
            dataSource1: params
        })
    }
    createMarkup(str) {
        return {__html: str}
    }
    computedData(data){
        if (data.label1 && data.label1.length>0){
            let str= ''
            data.label1.forEach(item=>{
                str+=item+'</br>'
            })
            return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
        }
    }
    computedData1(data){
        if (data.label2 && data.label2.length>0) {
            let str = ''
            data.label2.forEach(item => {
                str += item + '</br>'
            })
            return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
        }
    }
    computedData2(data){
        if (data.label3 && data.label3.length>0) {
            let str = ''
            data.label3.forEach(item => {
                str += item + '</br>'
            })
            return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
        }
    }

    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = {
            annual:this.state.annual,
            result:this.state.result,
            minscore:this.state.minscore,
            maxscore:this.state.maxscore,
            special:this.state.special,
            levelid:this.state.levelid,
            provinceid:this.state.provinceid === -1 ? '' : this.state.provinceid,
            museumname:this.state.museumname
        }
        newmuseumqueryHanndler(params).then(res=>{
            if (res.statecode === 0) {
                const arr = []
                res.records[0].levellist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].resultlist.forEach(item=>{
                    item.value = item.id
                })
                res.records[0].speciallist.forEach(item=>{
                    item.value = item.id
                })

                res.records[0].provincelist.forEach((item,index)=>{
                    if (index === 0) {
                        item.id = -1
                    }
                    item.value = item.id
                })
                let d = JSON.parse(JSON.stringify(res.records[0].museumlist))
                let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)

                const yearrange1 = res.records[0].annualmap
                let header = this.state.columns
                header[4].title = yearrange1[this.state.annual][0]+'年度'
                header[5].title = yearrange1[this.state.annual][1]+'年度'
                header[6].title = yearrange1[this.state.annual][2]+'年度'
                let headerindex = this.state.columns1
                headerindex[3].title = yearrange1[this.state.annual][0]+'年度'
                headerindex[4].title = yearrange1[this.state.annual][1]+'年度'
                headerindex[5].title = yearrange1[this.state.annual][2]+'年度'
                console.log(yearrange1);
                this.setState({
                    dataSource: data,
                    dataSourceAll:res.records[0].museumlist,
                    resultlist:res.records[0].resultlist,
                    speciallist:res.records[0].speciallist,
                    options: res.records[0].levellist,
                    loading:false,
                    citylist:res.records[0].provincelist,
                    page: {...this.state.page, total:res.records[0].museumlist.length},
                    yearrange1:yearrange1[this.state.annual],
                    columns:header,
                    columns1:headerindex
                });
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }
    deleteHandler(data){
        const params =
            {
                id:data.id
            }
        // specialadddetailHanndler(params).then(res=>{
        //     if (res.statecode === 0) {
        //         this.setState({
        //             detaildata:res.records,
        //             modal: {...this.state.modal, visible: true},
        //         })
        //     }
        // })
        // this.setState({
        //   modal: {...this.state.modal, visible: true},
        //   deleteid:data.id
        // })
    }


    componentWillMount(){
    }

    componentDidMount(){
        const yearrange = JSON.parse(localStorage.getItem('userList')).sysidlist
        const arr = []
        yearrange.forEach(item=>{
            let obj = {}
            obj.name = item
            obj.id = item
            obj.value = item
            arr.push(obj)
        })

        this.setState({
            ownerlist:arr,
            annual:arr[0].id,
        },()=>{
            this.getListData();
        })
    }

    render(){
        return (
            <div className='user-manage-list'>
                <div className='flex filter-wrap'>
                    <div className='filter-left' style={{width: '100%',display:'flex',flexWrap:'wrap'}}>
                        <div style={{marginBottom: '10px',width:'45%'}}>
                            <label htmlFor="" >
                                评估年度：</label>
                            <CSelect
                                value={this.state.annual}
                                options={this.state.ownerlist}
                                placeholder='请选择评估年度'
                                onChange={(e)=>{this.onChange('annual',e)}}
                                style={{width: '100px'}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'45%'}}>
                            <label htmlFor="" >
                                质量等级：</label>
                            <CRadio value={this.state.levelid}
                                    options={this.state.options}
                                    onChange={(e)=>{this.onChange('levelid',e)}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'45%'}}>
                            <label htmlFor="" style={{width:'90px'}}>
                                博物馆所处省份：</label>
                            <CSelect
                                value={this.state.provinceid}
                                options={this.state.citylist}
                                placeholder='请选择所处省份'
                                onChange={(e)=>{this.onChange('provinceid',e)}}
                                style={{width: '100px'}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'45%',display:'flex',alignItems:'center'}}>
                            <label htmlFor=""style={{width:'60px'}} >
                                名称：</label>
                            <CInput
                                value={this.state.museumname}
                                placeholder='请输入名称'
                                style={{width: '200px'}}
                                onChange={(e)=>{this.onChange('museumname',e)}}
                            />
                        </div>

                        <div style={{marginBottom: '10px',width:'45%'}}>
                            <label htmlFor="" >
                                评估成绩：</label>
                            <CRadio value={this.state.result}
                                    options={this.state.resultlist}
                                    onChange={(e)=>{this.onChange('result',e)}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'45%',display:'flex',alignItems:'center'}}>
                            <label htmlFor="" >
                                评估得分：</label>
                            <div style={{display:'flex',alignItems:'center'}}>
                                <CInput
                                    value={this.state.minscore}
                                    placeholder='请输入分数'
                                    style={{width: '100px'}}
                                    onChange={(e)=>{this.onChange('minscore',e)}}
                                />
                                <span style={{margin: '0 10px'}}>分至</span>
                                <CInput
                                    value={this.state.maxscore}
                                    placeholder='请输入分数'
                                    style={{width: '100px', marginRight: '10px'}}
                                    onChange={(e)=>{this.onChange('maxscore',e)}}
                                />
                            </div>
                        </div>
                        <div style={{marginBottom: '10px',width:'45%'}}>
                            <label htmlFor="" >
                                特色加分项：</label>
                            <CRadio value={this.state.special}
                                    options={this.state.speciallist}
                                    onChange={(e)=>{this.onChange('special',e)}}
                            />
                        </div>
                        <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
                        <CButton type='primary' onClick={this.download}>下载</CButton>
                    </div>
                </div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns}
                        dataSource={this.state.dataSource} page={this.state.page} onTableChange={this.onTableChange}>
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {index + 1}
                            </div>
                        )}/>
                    <div
                        slot='select1'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit'
                                         onClick={() => this.gotoindex(record, this.state.yearrange1[0])}>{record.label1[0]}</CButton>
                            </div>
                        )} />
                    <div
                        slot='select2'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoindex(record, this.state.yearrange1[1])}>{record.label2[0]}</CButton>
                            </div>
                        )} />
                    <div
                        slot='select3'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoindex(record, this.state.yearrange1[2])}>{record.label3[0]}</CButton>
                            </div>
                        )} />
                    <div
                        slot='chengji'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' authId='goodsManageListEdit' onClick={() => this.gotoDetail(record)}>{record.label4[0]}</CButton>
                            </div>
                        )} />
                </CTable>
                <Modal
                    title={this.state.modal.title}
                    visible={this.state.modal.visible}
                    onCancel={this.modalCancel}
                    width={960}
                    footer={null}
                >
                    <div>
                        <div>
                            指标项显示层级：
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(4)} style={{marginRight:'20px'}}>
                                全部
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(3)} style={{marginRight:'20px'}}>
                                三级及以上
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(2)} style={{marginRight:'20px'}}>
                                二级及以上
                            </CButton>
                        </div>
                        <CTable ref='historyRecordDeleteUserList1' checked={false} loading={false} columns={this.state.columns1} dataSource={this.state.dataSource1}>
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            <div
                                slot='operate2019'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2020'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData1(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2021'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData2(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            {/*<div*/}
                            {/*    slot='pjf'*/}
                            {/*    render={(text, record, index) => (*/}
                            {/*        <div className='operate'>*/}
                            {/*            {this.computedScore(record)}*/}
                            {/*        </div>*/}
                            {/*    )} />*/}
                        </CTable>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReload: bindActionCreators(setReload, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        setYear:bindActionCreators(setYear,dispatch),
        setLibrary:bindActionCreators(setLibrary,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
